import api from './../utils/api';


export const sendCard = async (pin, seri, card_type, card_value) => {
    try {
        const response = await api.post(`/payment/send-card`,
            {
                pin,
                seri,
                card_type,
                card_value
            },
            {
                withCredentials: true
            }
        );

        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getCardRatesForAdmin = async () => {
    try {
        const response = await api.get(`/payment/card/rates`, {
            withCredentials: true
        });

        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getCardRatesForUser = async (cardType, cardValue) => {
    try {
        const response = await api.get(`/payment/card/rates/user`, {
            params: {
                cardType,
                cardValue
            },
            withCredentials: true
        });

        return response.data;
    } catch (error) {
        throw error;
    }
};

export const updateCardRatesForAdmin = async (updates) => {
    try {
        const response = await api.put(
            `/payment/card/rates`,
            { updates },
            { withCredentials: true }
        );
        return response.data;
    } catch (error) {
        throw error;
    }
};
